import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import SquareFootOutlinedIcon from "@mui/icons-material/SquareFootOutlined";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";

// Survey questionnaire per the PRD's "Survey Questionnaire" spec (Section
// 9) — the definitive question set, shared across the homepage survey, the
// contractor listing, and the get-in-touch flow. Property type branches into
// either a BHK count (residential) or a sq. footage bracket (commercial); the
// budget question follows the size question for both.
export const RESIDENTIAL_PROPERTY_TYPES = ["Apartment", "Independent House", "Villa"];
export const COMMERCIAL_PROPERTY_TYPE = "Office / Commercial Space";

export const PROPERTY_TYPE_QUESTION = {
  id: "propertyType",
  icon: HomeWorkOutlinedIcon,
  question: "What type of property is this?",
  reviewLabel: "Property type",
  optional: false,
  options: [...RESIDENTIAL_PROPERTY_TYPES, COMMERCIAL_PROPERTY_TYPE],
};

export const BHK_QUESTION = {
  id: "bhk",
  icon: BedOutlinedIcon,
  question: "How many bedrooms (BHK)?",
  reviewLabel: "Bedrooms (BHK)",
  optional: false,
  options: ["1 BHK", "2 BHK", "3 BHK", "4 BHK", "4+ BHK"],
};

export const SQFT_QUESTION = {
  id: "sqft",
  icon: SquareFootOutlinedIcon,
  question: "Roughly how big is the space?",
  reviewLabel: "Estimated sq. footage",
  optional: false,
  options: [
    "Less than 1,000 sq.ft.",
    "1,000-2,000 sq.ft.",
    "2,000-3,000 sq.ft.",
    "3,000-4,000 sq.ft.",
    "4,000-5,000 sq.ft.",
    "More than 5,000 sq.ft.",
  ],
};

export const BUDGET_QUESTION = {
  id: "budget",
  icon: CurrencyRupeeIcon,
  question: "What is your approximate Budget?",
  reviewLabel: "Approximate budget",
  optional: false,
  options: ["<5 Lacs", "5 - 10 Lacs", "10 - 15 Lacs", "15 - 20 Lacs", "above 20 Lacs"],
};

export const TIMELINE_QUESTION = {
  id: "timeline",
  icon: EventOutlinedIcon,
  question: "When do you want to start the project?",
  reviewLabel: "Project start timeline",
  optional: false,
  options: ["Immediately", "Within 1 month", "1-3 months", "3-6 months", "Just exploring"],
};

export const HAS_DESIGNS_QUESTION = {
  id: "hasDesigns",
  icon: DesignServicesOutlinedIcon,
  question: "Do you already have designs?",
  reviewLabel: "Do you already have designs?",
  optional: true,
  options: ["Yes", "No"],
};

// Every question that could ever appear, regardless of branching — used by
// ProjectDetailsCard to show whichever of BHK/sq.footage was actually
// answered without needing its own branching logic.
export const ALL_SURVEY_QUESTIONS = [
  PROPERTY_TYPE_QUESTION,
  BHK_QUESTION,
  SQFT_QUESTION,
  BUDGET_QUESTION,
  TIMELINE_QUESTION,
  HAS_DESIGNS_QUESTION,
];

// The ordered list of questions to actually render for the current answers:
// property type first, then whichever of BHK/sq.footage applies once
// property type is answered, then budget, timeline and has-designs.
export function getSurveyQuestionFlow(answers = {}) {
  const questions = [PROPERTY_TYPE_QUESTION];

  if (answers.propertyType) {
    const isCommercial = answers.propertyType === COMMERCIAL_PROPERTY_TYPE;
    questions.push(isCommercial ? SQFT_QUESTION : BHK_QUESTION);
    questions.push(BUDGET_QUESTION, TIMELINE_QUESTION, HAS_DESIGNS_QUESTION);
  }

  return questions;
}
